import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../state/AppStore'
import { updateService } from '../UpdateService'
import { websocketConnection } from './Websockets'
import { WebsocketConnectionStatus } from './WebsocketConnectionStatus'

export const usePublicWebsocketConnection = () =>
{
	const userId = useSelector((root: RootState) => root.publicUser.userId)
	const websocketConnectionStatus = useSelector((root: RootState) => root.websocketConnection.status)

	useEffect(() => {
		if (userId) {
			websocketConnection.setup(userId)
			websocketConnection.connect()

			updateService.setup()
		} else {
			updateService.cleanup()
			websocketConnection.disconnect()
		}

		return () => {
			websocketConnection.disconnect()
		}
	}, [userId])

	useEffect(() => {
		if (websocketConnectionStatus === WebsocketConnectionStatus.Connected) {
			updateService.refreshRooms()
		}
	}, [websocketConnectionStatus])
}
